import merge from 'lodash.merge'
import defaultTheme, { Theme, ThemeOverride } from './default'

export const buildTheme = (themeOverride: ThemeOverride): Theme =>
  merge(defaultTheme, themeOverride)
